module.exports = __webpack_public_path__ + "static/media/office.a24741b9.jpg";